import React from 'react'
import setStyle from '@/utils/setStyle'
import HTag from '@/lib/HTag'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import nl2br from '@/utils/nl2br'
import clsx from 'clsx'
import logo from '@/images/stepuplogo.png'

const SimpleCarousel = ({ heading, items, style, blockId }) => (
	<section id={blockId} className={setStyle(style)}>
		<div className="section text-center">
			<HTag className="h1" {...heading} />

			<ul className={clsx('carousel gap-8 <md:gap-4 mt-8', style === 'tan' && 'text-grounding-navy')}>
				{items?.map((item, key) => (
					<CarouselItem {...item} key={key} />
				))}
			</ul>
		</div>
	</section>
)

const CarouselItem = ({ title, subtitle, cta, image }) => (
	<li className="grow-0 shrink-0 richtext text-lg">
		<figure data-aos="fade-down" className="rounded-full overflow-hidden">
			{!!image
				? <Img image={image} alt={title} />
				: <img src={logo} alt={title} />
			}
		</figure>
		<p data-aos="fade-right" className="h2 text-orange">{title}</p>
		{!!subtitle && <p>{nl2br(subtitle)}</p>}
		<p><CTA {...cta} arrow /></p>
	</li>
)

export default SimpleCarousel
